import styled from '@emotion/styled'
import React from 'react'

export const SwingNeedle = () => {
    return (
        <StyledSvg
            viewBox="0 0 11 110"
            fill="none"
            width="100%"
            height="100%"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M0 22.1148C0 21.2631 0.104447 20.4147 0.311003 19.5885L3.52392 6.73683C3.96224 4.98351 6.454 4.98351 6.89233 6.73683L10.1052 19.5885C10.3118 20.4147 10.4162 21.2631 10.4162 22.1148L10.4162 104.162C10.4162 107.039 8.08449 109.371 5.20812 109.371C2.33176 109.371 0 107.039 0 104.162L0 22.1148Z"
                fill="#393939"
            />
            <circle cx="5.20923" cy="104.161" r="3.47208" fill="white" />
        </StyledSvg>
    )
}

const StyledSvg = styled.svg({
    height: '30%',
    translate: '0 -45%',
})
